import React from 'react';
import { useTopLevelLinks } from '../../../useTopLevelLinks';
import { FooterMenuWrapper, StyledLinkV2, styles } from './FooterMenu.styles';

export const FooterMenu: React.FC = () => {
  const topLevelLinks = useTopLevelLinks();
  return (
    <FooterMenuWrapper __css={styles.footerMenuWrapper}>
      <StyledLinkV2
        id={topLevelLinks.shipping.id}
        href={topLevelLinks.shipping.href}
        target={topLevelLinks.shipping.target}
        onClick={topLevelLinks.shipping.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.shipping.label}
      </StyledLinkV2>
      <StyledLinkV2
        id={topLevelLinks.returns.id}
        href={topLevelLinks.returns.href}
        target={topLevelLinks.returns.target}
        onClick={topLevelLinks.returns.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.returns.label}
      </StyledLinkV2>
      <StyledLinkV2
        id={topLevelLinks.newsroom.id}
        href={topLevelLinks.newsroom.href}
        target={topLevelLinks.newsroom.target}
        onClick={topLevelLinks.newsroom.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.newsroom.label}
      </StyledLinkV2>
      <StyledLinkV2
        id={topLevelLinks.careers.id}
        href={topLevelLinks.careers.href}
        target={topLevelLinks.careers.target}
        onClick={topLevelLinks.careers.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.careers.label}
      </StyledLinkV2>
      <StyledLinkV2
        id={topLevelLinks.aboutJoy.id}
        href={topLevelLinks.aboutJoy.href}
        target={topLevelLinks.aboutJoy.target}
        onClick={topLevelLinks.aboutJoy.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.aboutJoy.label}
      </StyledLinkV2>
      <StyledLinkV2
        id={topLevelLinks.contactUs.id}
        href={topLevelLinks.contactUs.href}
        target={topLevelLinks.contactUs.target}
        onClick={topLevelLinks.contactUs.onClick}
        typographyVariant="FeatureCopy17"
      >
        {topLevelLinks.contactUs.label}
      </StyledLinkV2>
    </FooterMenuWrapper>
  );
};
